import React from 'react'


function NavNotice() {
  // return (
  //   <li className='nav-item dropdown'>
  //       <a href="#" className='nav-link-icon' data-bs-toggle='dropdown'>
  //           <i className='bi bi-bell'></i>
  //           <span className='badge bg-primary badge-number'>4</span>

  //       </a>

  //       <ul className='dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications'>
  //           <li className='dropdown-header'>
  //           You Have 4 new Notifications
  //           <a href="#"></a>
  //           <span className='badge rounded-pill bg-primary p-2 ms-2'>View all</span>
  //           </li>
  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='notification-item'>
  //               <i className='bi bi-exclamation-circle text-warning'></i>
  //               <div>
  //                   <h4>Tickets</h4>
  //                   <p>10 tickets batches ready</p>
  //                   <p>10min. ago</p>
  //               </div>

  //           </li>
  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='notification-item'>
  //               <i className='bi bi-exclamation-circle text-warning'></i>
  //               <div>
  //                   <h4>Sales Sheets</h4>
  //                   <p>Sales sheets ready</p>
  //                   <p>10min. ago</p>
  //               </div>

  //           </li>

  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='notification-item'>
  //               <i className='bi bi-exclamation-circle text-warning'></i>
  //               <div>
  //                   <h4>Sales Sheets</h4>
  //                   <p>Sales sheets ready</p>
  //                   <p>10min. ago</p>
  //               </div>

  //           </li>

  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='notification-item'>
  //               <i className='bi bi-exclamation-circle text-warning'></i>
  //               <div>
  //                   <h4>Sales Sheets</h4>
  //                   <p>Sales sheets ready</p>
  //                   <p>10min. ago</p>
  //               </div>

  //           </li>
  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='dropdown-footer'>
  //             <a href='#'>Show all notifications</a>  
  //           </li>

  //       </ul>

  //   </li>
    
  // );
}

export default NavNotice